import { format, isToday, isYesterday } from 'date-fns'

import { getCurrentLocale } from '@probatix/common/translations'
import { t } from 'i18next'

export const formatDateLocale = (date: Date, dateFormat: string) => {
  const locale = getCurrentLocale()

  return format(date, dateFormat, { locale })
}

export const formatDateByLocale = (date: Date | string) => {
  try {
    const locale = getCurrentLocale()
    const d = 'string' === typeof date ? new Date(date) : date

    if ("de" === locale.code) {
      return format(d, 'd. MMMM yyyy, HH:mm', { locale: locale })

    } else {

      return format(d, 'd MMMM yyyy, HH:mm', { locale: locale })
    }
  } catch (error) {
    return ''
  }
}

export function formatFriendlyDateGerman(date: Date | string): string {
  try {
    const d = 'string' === typeof date ? new Date(date) : date
    const now = new Date()
    const uhr = t('global:oclock')
    const locale = getCurrentLocale()

    if (isToday(d)) {
      const time = format(d, "HH:mm", { locale: locale })

      return `${t('global:today')}, ${time} ${uhr}`
    }

    if (isYesterday(d)) {
      const time = format(d, "HH:mm", { locale: locale })

      return `${t('global:yesterday')}, ${time} ${uhr}`
    }
    //20. Juni 2025, 10:02 Uhr

    const customRelativeLocale = {
      lastWeek: (dateToFormat: Date) => {
        const weekday = format(dateToFormat, 'EEEE', { locale: locale })
        const time = format(dateToFormat, 'HH:mm', { locale: locale })

        return `${weekday}, ${time} ${uhr}`
      },
      other: (dateToFormat: Date) => {        
        const formatted =  format(dateToFormat, `d. MMMM yyyy, HH:mm`, { locale: locale })

        return `${formatted} ${uhr}`
      },
    }

    const diffDays = Math.floor((d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
    if (-2 >= diffDays && -6 <= diffDays) {
      return customRelativeLocale.lastWeek(d)
    }

    return customRelativeLocale.other(d)

  } catch {

    return ''
  }
}
